import ApplicationController from '../../support/application_controller'
import { disableElement } from '../../support/helpers'

export default class extends ApplicationController {

  static targets = [
    'disableOnSubmit',
    'submit'
  ]

  // ==== Controllers

  // ==== Actions

  enableSubmit() {
    this.submitTarget.disabled = false
  }

  submit() {
    for (const el of this.disableOnSubmitTargets) {
      disableElement(el)
    }
  }

  // ==== Getters

  // ==== Setters

  // ==== Private

  // ==== Channels

}
